/* Rhino Spice v2.0.5.2: cart progress only. Shopify determines actual discounts. */
(() => {
  let pending = false;
  const normalize = value => String(value || '').toLowerCase();
  const update = async () => {
    if (pending) return;
    pending = true;
    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin'});
      if (!response.ok) return;
      const cart = await response.json();
      let bottles = 0;
      let singles = 0;
      let bundles = 0;
      for (const item of cart.items || []) {
        const name = normalize(item.product_title);
        const handle = normalize(item.handle);
        if (name.includes('four-pack variety bundle') || handle.includes('four-pack-variety-bundle')) {
          bottles += item.quantity * 4;
          bundles += item.quantity;
        } else if (name.includes('rhino spice') || ['original','smokey','zesty'].some(x => handle.includes(x))) {
          bottles += item.quantity;
          singles += item.quantity;
        }
      }
      const remain = Math.max(0,4-bottles);
      document.querySelectorAll('[data-rhino-cart-progress]').forEach(el => {
        const heading = el.querySelector('[data-rhino-progress-heading]');
        const message = el.querySelector('[data-rhino-progress-message]');
        const fill = el.querySelector('[data-rhino-progress-fill]');
        const count = el.querySelector('[data-rhino-progress-count]');
        if (!heading || !message || !fill || !count) return;
        heading.textContent = remain ? "You're almost there!" : 'Four-bottle milestone reached!';
        message.textContent = remain
          ? `Add ${remain} more qualifying ${remain===1?'bottle':'bottles'} to reach four. Each Four-Pack counts as four.`
          : singles > 0
            ? `Your ${bundles ? 'Four-Pack counts as four bottles, and your ' : ''}${singles} individual ${singles===1?'bottle qualifies':'bottles qualify'} for $1 off each when the eligible promotion is applied at checkout. Four-Packs remain $29.99 each.`
            : 'Each Four-Pack counts as four bottles toward the savings threshold. Four-Packs remain $29.99 each; add individual bottles to receive $1 off each when the eligible promotion is applied at checkout.';
        fill.style.width = `${Math.min(100,bottles/4*100)}%`;
        count.textContent = bottles >= 4 ? `${bottles} qualifying bottles — milestone reached` : `${bottles} of 4 bottles`;
      });
    } catch(e) { /* Never block the native Shopify cart. */ }
    finally { pending=false; }
  };
  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('click', e => {
    if (e.target.closest('a[href*="/cart"], button, .cart-count-bubble, cart-drawer')) {
      setTimeout(update, 450);
      setTimeout(update, 1200);
    }
  });
  if (window.subscribe && window.PUB_SUB_EVENTS) {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, update);
  }
})();
